import React from "react";
import { toast } from "react-toastify";
import { getApiErrorMessages } from "./apiErrors";

// One place for reporting a failed API call. Shows every message the server
// sent, so validation errors reach the user instead of a generic line.
// Returns the messages so a caller can also show them inline.
export function showApiError(error, { autoClose = 6000 } = {}) {
  const messages = getApiErrorMessages(error);
  toast.error(
    <div>{messages.map((message, index) => <div key={index}>{message}</div>)}</div>,
    { position: "top-right", autoClose }
  );
  return messages;
}

export function showApiSuccess(message, { autoClose = 3000 } = {}) {
  toast.success(message, { position: "top-right", autoClose });
  return message;
}

// Shown when a form is blocked by its own checks, so the user is not left
// wondering why nothing happened. The fields themselves carry the detail.
export function showFormError(message = "Please fix the highlighted fields", { autoClose = 3000 } = {}) {
  toast.error(message, { position: "top-right", autoClose });
  return message;
}
